var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerpetratorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.824 79.043)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6670",
    "data-name": "Rect\\xE1ngulo 6670",
    width: 23,
    height: 23,
    transform: "translate(0.824 -79.043)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-hacker-1381807",
    transform: "translate(2.737 -76.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9613",
    "data-name": "Trazado 9613",
    d: "M18.7,17.382l-2.155-.906a3.081,3.081,0,0,0-1.068-3.536l-.418-.311a7.082,7.082,0,0,0,.215-.98,3.145,3.145,0,0,0,1.119-2.39,1.536,1.536,0,0,0-.456-1.1,1.556,1.556,0,0,0-.426-.3V5.943a3.02,3.02,0,0,0-1.854-2.978,16.68,16.68,0,0,0-2.4-.992V1.718a.5.5,0,0,0-1,0v.255c-.4.133-1.117.41-2.37.982A2.915,2.915,0,0,0,6,5.943V7.857a1.558,1.558,0,0,0-.4.281,1.534,1.534,0,0,0-.474,1.115A3.137,3.137,0,0,0,6.3,11.685a7.015,7.015,0,0,0,.2.928l-.454.335a3.081,3.081,0,0,0-1.068,3.536l-2.153.9A2.96,2.96,0,0,0,1,20.161a.5.5,0,0,0,.5.492h0a.5.5,0,0,0,.5-.5A1.968,1.968,0,0,1,3.2,18.306l2.253-.948a3.1,3.1,0,0,0,.4.426l2.263,1.952a.5.5,0,1,0,.649-.751L6.514,17.032a2.105,2.105,0,0,1,.12-3.285l.227-.167a5.4,5.4,0,0,0,.486.823v1.6a.5.5,0,0,0,.181.384l2.914,2.39a.5.5,0,0,0,.631,0l2.914-2.39a.5.5,0,0,0,.181-.384V14.452a5.328,5.328,0,0,0,.516-.859l.2.147A2.105,2.105,0,0,1,15,17.026L12.751,18.98a.5.5,0,0,0,.651.755l2.263-1.952a3.1,3.1,0,0,0,.4-.426l2.251.95a1.968,1.968,0,0,1,1.209,1.839.5.5,0,0,0,.492.5h0a.5.5,0,0,0,.5-.494A2.96,2.96,0,0,0,18.7,17.382ZM8.305,3.855a21.616,21.616,0,0,1,2.442-1,16.951,16.951,0,0,1,2.434.982A2.065,2.065,0,0,1,14.52,5.947V7.17l-.175-.108a6.99,6.99,0,0,0-7.171,0L7,7.166V5.943A1.949,1.949,0,0,1,8.305,3.855Zm5.952,4.312L14,8.66a.472.472,0,0,1-.635.2,5.952,5.952,0,0,0-2.607-.711,5.952,5.952,0,0,0-2.617.7.47.47,0,0,1-.363.03.45.45,0,0,1-.263-.227l-.247-.49L7.7,7.909a5.994,5.994,0,0,1,6.151,0Zm-.908,5.709a.9.9,0,0,0-.183.54v1.354l-2.406,1.98-2.416-1.98V14.376a.89.89,0,0,0-.173-.54,5.378,5.378,0,0,1-.922-2.482A.5.5,0,0,0,7.038,11,2.143,2.143,0,0,1,6.12,9.251a.546.546,0,0,1,.167-.4.564.564,0,0,1,.151-.1l.179.355a1.438,1.438,0,0,0,.845.723,1.458,1.458,0,0,0,1.123-.088,4.962,4.962,0,0,1,2.173-.6,4.964,4.964,0,0,1,2.165.6A1.47,1.47,0,0,0,14.9,9.114l.177-.368a.566.566,0,0,1,.163.112.54.54,0,0,1,.161.4,2.147,2.147,0,0,1-.884,1.729.5.5,0,0,0-.2.347A5.342,5.342,0,0,1,13.349,13.876Z",
    transform: "translate(-0.999 -1.22)",
    fill: "#fa526c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9614",
    "data-name": "Trazado 9614",
    d: "M83.818,60.564h.857a1.151,1.151,0,0,0,1.149-1.149v-.857a.5.5,0,1,0-1,0v.857a.153.153,0,0,1-.153.153h-.857a.5.5,0,1,0,0,1Z",
    transform: "translate(-66.922 -46.738)",
    fill: "#fa526c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9615",
    "data-name": "Trazado 9615",
    d: "M83.818,11h.857a.153.153,0,0,1,.153.153v.857a.5.5,0,1,0,1,0v-.857A1.151,1.151,0,0,0,84.674,10h-.857a.5.5,0,1,0,0,1Z",
    transform: "translate(-66.922 -8.251)",
    fill: "#fa526c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9616",
    "data-name": "Trazado 9616",
    d: "M4.608,12.508a.5.5,0,0,0,.5-.5v-.857A.153.153,0,0,1,5.259,11h.857a.5.5,0,0,0,0-1H5.259A1.151,1.151,0,0,0,4.11,11.149v.857a.5.5,0,0,0,.5.5Z",
    transform: "translate(-3.49 -8.251)",
    fill: "#fa526c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9617",
    "data-name": "Trazado 9617",
    d: "M5.259,60.564h.857a.5.5,0,1,0,0-1H5.259a.153.153,0,0,1-.153-.153v-.857a.5.5,0,0,0-1,0v.857a1.151,1.151,0,0,0,1.149,1.149Z",
    transform: "translate(-3.49 -46.738)",
    fill: "#fa526c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9618",
    "data-name": "Trazado 9618",
    d: "M45.868,58.06h-1.41a.5.5,0,1,0,0,1H45.87a.5.5,0,1,0,0-1Z",
    transform: "translate(-35.403 -46.738)",
    fill: "#fa526c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9619",
    "data-name": "Trazado 9619",
    d: "M43.852,16.623a.5.5,0,0,0,.353-.145.671.671,0,0,1,.948,0,.5.5,0,0,0,.705-.705,1.669,1.669,0,0,0-2.356,0,.5.5,0,0,0,.351.851Z",
    transform: "translate(-34.918 -12.484)",
    fill: "#fa526c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerpetratorRed);
export default __webpack_public_path__ + "static/media/icon-perpetrator-red.7227284db9e0fd07cf79f61b6d0e9d2a.svg";
export { ForwardRef as ReactComponent };